module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "input marginBtm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入电话"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-shouji"
  })]), _vm._v(" "), _c('div', {
    staticClass: "input marginBtm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "短信验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-iconzhenghe0729fuzhi93"
  }), _vm._v(" "), (_vm.recommendToken) ? _c('div', {
    staticClass: "code",
    on: {
      "click": function($event) {
        return _vm.getSignature(_vm.recommendToken)
      }
    }
  }, [_vm._v("获取")]) : (_vm.recommendCode) ? _c('div', {
    staticClass: "code",
    on: {
      "click": function($event) {
        return _vm.getSignature(_vm.recommendCode)
      }
    }
  }, [_vm._v("获取")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input marginBtm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-mima"
  })]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords),
      expression: "passwords"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请重复密码"
    },
    domProps: {
      "value": (_vm.passwords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-mima"
  })]), _vm._v(" "), (_vm.recommendToken) ? _c('button', {
    attrs: {
      "type": "botton"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("注册")]) : (_vm.recommendCode) ? _c('button', {
    attrs: {
      "type": "botton"
    },
    on: {
      "click": _vm.referralRegister
    }
  }, [_vm._v("注册")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": "static/img/banner.png"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0262807c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0262807c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register.vue
// module id = 246
// module chunks = 1